var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V20H11V0H9ZM0 4C0 2.89543 0.89543 2 2 2H5C6.10457 2 7 2.89543 7 4V16C7 17.1046 6.10457 18 5 18H2C0.89543 18 0 17.1046 0 16V4ZM18 4V16H15V4H18ZM15 2C13.8954 2 13 2.89543 13 4V16C13 17.1046 13.8954 18 15 18H18C19.1046 18 20 17.1046 20 16V4C20 2.89543 19.1046 2 18 2H15Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.7d35debb958ae42f5c5003732495b347.svg";
export { ForwardRef as ReactComponent };